import defaultErrorHandler from "actions/global/default-error-handler";
import {
  requestAggregationGetUser
} from "actions/aggregation/requests";

import {
  AGGREGATION_LOADING,
  AGGREGATION_ERROR,
  AGGREGATION_GET_USER
} from "actions/aggregation/constants";

export const setLoading = (status) => ({
  type: AGGREGATION_LOADING,
  payload: status
});

export const aggregationGetUser = (userId) => dispatch => {
  dispatch(setLoading(true));
  requestAggregationGetUser(userId)
    .then(response => {
      dispatch({
        type: AGGREGATION_GET_USER,
        payload: response.data.content
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, AGGREGATION_ERROR));
    });
};

export const aggregationResetUser = () => dispatch => {
  dispatch({
    type: AGGREGATION_GET_USER,
    payload: []
  });
};



// WEBPACK FOOTER //
// ./src/actions/aggregation/actions.js